import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function createItemApi() {
  const apiUrlTest = "/gateway/edi/product/upsert"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.itemDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/product/upsert"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/gateway/edi/product/upsert"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/product/upsert"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value: "https://openapi.jtfulfillment.cn/gateway/edi/product/upsert"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],

      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "itemCode",
              type: "varchar(50)",
              require: "Y",
              normal: "YL001",
              describe: "apiDocDesc.itemCodeDesc1"
            },
            {
              name: "customerid",
              type: "varchar(50)",
              require: "Y",
              normal: "CS001",
              describe: "apiDocDesc.customeridDesc2"
            },
            {
              name: "actionType",
              type: "varchar",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.actionTypeDesc3"
            },
            {
              name: "warehouseCode",
              type: "varchar(50)",
              require: "Y",
              normal: "SH.001",
              describe: "apiDocDesc.warehouseCodeDesc4"
            },
            {
              name: "itemName",
              type: "varchar(500)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.itemNameDesc5"
            },
            {
              name: "shortName",
              type: "varchar(500)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.shortNameDesc6"
            },
            {
              name: "userDef1",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.userDef1"
            },
            {
              name: "parentCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.parentCode"
            },
            {
              name: "itemStyle",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.itemStyle"
            },
            {
              name: "packingClass",
              type: "varchar(255)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.packingClass"
            },
            {
              name: "size",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sizeDesc7"
            },
            {
              name: "color",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.colorDesc8"
            },
            {
              name: "goodsLong",
              type: "decimal(15,4)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.goodsLongDesc9"
            },
            {
              name: "goodsWidth",
              type: "decimal(15,4)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.goodsWidthDesc10"
            },
            {
              name: "goodsHeight",
              type: "decimal(15,4)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.goodsHeightDesc11"
            },
            {
              name: "weight",
              type: "decimal(15,4)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.weightDesc12"
            },
            {
              name: "netWeight",
              type: "decimal(15,4)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.netWeight"
            },
            {
              name: "imageUrl",
              type: "varchar(500)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.imageUrlDesc13"
            },
            {
              name: "itemType",
              type: "varchar(255)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.itemTypeDesc14"
            },
            {
              name: "csDesc",
              type: "varchar(50)",
              require: "N",
              normal: "apiDocDesc.csDescNormal",
              describe: "apiDocDesc.csDesc"
            },
            {
              name: "boxQty",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.boxQtyDesc15"
            },
            {
              name: "unit",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.unitDesc16"
            },
            {
              name: "isFragile",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isFragile"
            },
            {
              name: "isHazardous",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isHazardous"
            },
            {
              name: "isLiquid",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isLiquid"
            },
            {
              name: "packageUnit",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.packageUnitDesc17"
            },
            {
              name: "isElectricity",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isElectricityDesc18"
            },
            {
              name: "electricityCapacity",
              type: "varchar(100)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.electricityCapacityDesc19"
            },
            {
              name: "expiration",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.expirationDesc20"
            },
            {
              name: "expirationDate",
              type: "int",
              require: "C",
              normal: "",
              describe: "apiDocDesc.expirationDateDesc21"
            },
            {
              name: "rejectLifecycle",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.rejectLifecycleDesc22"
            },
            {
              name: "lockupLifecycle",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.lockupLifecycleDesc23"
            },
            {
              name: "adventLifecycle",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.adventLifecycleDesc24"
            },
            {
              name: "isSNMgmt",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isSNMgmtDesc25"
            },
            {
              name: "SNMgmt",
              type: "int",
              require: "C",
              normal: "",
              describe: "apiDocDesc.SNMgmtDesc26"
            },
            {
              name: "reserved1",
              type: "json",
              require: "N",
              normal: "",
              describe: "apiDocDesc.reserved1Desc27"
            },
            {
              name: "barcodes[]/barcode",
              type: "array",
              require: "Y",
              normal: "",
              describe: "",
              children: [
                {
                  name: "barcode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.barcodeDesc28"
                },
                {
                  name: "quantityUM",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.quantityUMDesc28"
                }
              ]
            },
            {
              name: "isBatchMgmt",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isBatchMgmtDesc29"
            },
            {
              name: "isLotMgmt",
              type: "int",
              require: "N",
              normal: "",
              describe: "apiDocDesc.isLotMgmtDesc30"
            },
            {
              name: "supplierCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.supplierCodeDesc31"
            },
            {
              name: "originAddress",
              type: "varchar(100)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.originAddress"
            },
            {
              name: "approvalNumber",
              type: "varchar(100)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.approvalNumber"
            },
            {
              name: "supplierName",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.supplierNameDesc32"
            },
            {
              name: "currencyId",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.currencyIdDesc33"
            },
            {
              name: "tagPrice",
              type: "decimal(15,4)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.tagPriceDesc34"
            },
            {
              name: "costPrice",
              type: "decimal(15,4)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.costPriceDesc35"
            },
            {
              name: "unitPrice",
              type: "decimal(15,4)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.unitPriceDesc36"
            },
            {
              name: "purchasePrice",
              type: "decimal(15,4)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.purchasePriceDesc37"
            },
            {
              name: "brandCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.brandCodeDesc38"
            },
            {
              name: "brandName",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.brandNameDesc39"
            },
            {
              name: "countryCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.countryCodeDesc40"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "itemCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.itemCodeDesc41"
            },
            {
              name: "success",
              type: "",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc42"
            },
            {
              name: "reason",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.reasonDesc43"
            },
            {
              name: "message",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.messageDesc44"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        warehouseCode: "SH.001",
        unitPrice: "6",
        customerid: "MABANG-TEST",
        actionType: "add",
        itemCode: "20240524164027900",
        itemName: "ben",
        shortName: "pen",
        userDef1: "pen",
        parentCode: "12345",
        itemStyle: "red",
        packingClass: "文具",
        color: "绿色",
        currencyId: "PHP",
        size: "1*1*1",
        itemType: "ZC",
        csDesc: "包",
        weight: "0.5",
        netWeight: "0.5",
        goodsLong: "1.5",
        goodsWidth: "2.5",
        goodsHeight: "3.5",
        isElectricity: "1",
        electricityCapacity: "10.01",
        expiration: "1",
        expirationDate: "365",
        boxQty: "2",
        isFragile: "0",
        isHazardous: "0",
        isLiquid: "0",
        originAddress: "上海",
        approvalNumber: "1234567",
        barcodes: [
          {
            barcode: "20240524164027900",
            quantityUM: "EA"
          }
        ]
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        responseitems: [
          {
            itemCode: "20240524164027900",
            success: "true",
            reason: "",
            message: ""
          }
        ]
      }
    }
  };
}
